import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store";
import { UserRole } from "@/services/types/common.types";

interface RoleBasedRouteProps {
  children: React.ReactNode;
  roles: UserRole[];
  /** Users holding any of these roles are refused, even when they hold an allowed role. */
  deniedRoles?: UserRole[];
}

export function RoleBasedRoute({
  children,
  roles,
  deniedRoles = [],
}: RoleBasedRouteProps) {
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Logged in but unauthorized
  const userRoles = user?.roles ?? [];

  const hasAccess =
    roles.some((role) => userRoles.includes(role)) &&
    !deniedRoles.some((role) => userRoles.includes(role));

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}
